<template>
    <div>
        <div v-bind:class="ifLoading" class="loader">
            <TheSpinner />
        </div>
        <div v-if="loading">
            <div class="p-5 pb-3 md:pl-12">
                <the-title parentcolor="orange">
                    <slot slot="de">
                        {{items[0].name_de}} / Wähle ein Turnier:
                    </slot>
                    <slot slot="en">
                        {{items[0].name_en}} / Select a tournament:
                    </slot>
                </the-title>
            </div>
            <ul class="mb-5">
                <li :key="sportartItem.ID" v-for="sportartItem in items[1]['detail']" class="inline-block uppercase font-extrabold text-primary-red gradientText border-0 border-b-2 border-secondary-grey w-full md:w-2/4 md:text-5xl px-8 md:pl-12 py-6 md:py-12" v-if="sportartItem.name_de">
                    <router-link  v-bind:to="sportartItem.router">
                        <the-language :de="sportartItem.name_de" :en="sportartItem.name_en" v-if="sportartItem.name_de"/>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import TheTitle from "../TheTitle";
    import TheLanguage from "../TheLanguage";
    import TheSpinner from "../TheSpinner"

    export default {
        name: 'homepage',
        components: {
            TheSpinner,
            TheLanguage,
            TheTitle
        },
        data(){
            return{
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/sportselectdetail/'+this.$route.params.id+'.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
